// Parser for the markdown-lite used in Nyhet.brodtext: paragraphs separated
// by blank lines, **bold** spans, and the {bugg} token for the header's
// report-a-problem glyph. Nothing else — news bodies are written by us, but
// they still never reach the DOM or an email as raw HTML. One parser, two
// renderers: the popup (React, draws the glyph inline) and byggNyhetsMejl
// (inline-styled email HTML with escapeHtml on every span; the glyph is
// dropped there since inline SVG is unreliable in mail clients).

export interface BrodtextSpan {
  text: string;
  bold: boolean;
  /** Inline glyph instead of text. Renderers that cannot draw it skip it. */
  ikon?: "bugg";
}

export type BrodtextStycke = BrodtextSpan[];

export function parseBrodtext(brodtext: string): BrodtextStycke[] {
  return brodtext
    .split(/\n\s*\n/)
    .map((stycke) => stycke.trim())
    .filter((stycke) => stycke.length > 0)
    .map((stycke) => {
      const spans: BrodtextSpan[] = [];
      // Split on **…** groups; odd indices are the bold contents.
      const delar = stycke.split(/\*\*(.+?)\*\*/g);
      delar.forEach((del, i) => {
        if (del.length === 0) return;
        const bold = i % 2 === 1;
        // Icon tokens are only recognised outside bold spans.
        if (bold) {
          spans.push({ text: del, bold });
          return;
        }
        del.split(/\{bugg\}/g).forEach((bit, j) => {
          if (j > 0) spans.push({ text: "", bold: false, ikon: "bugg" });
          if (bit.length > 0) spans.push({ text: bit, bold: false });
        });
      });
      return spans;
    });
}
